import { Anchor } from '@components/Anchor';
import { DataTable } from '@components/Table/DataTable';
import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IModalWindow } from '@hooks/useModalWindow';
import { TableBody, TableCell, TableContainerProps, TableHead, TableRow } from '@material-ui/core';
import { EnumCaixaTipoLancamento } from '@model/CaixaTipoLancamento';
import { ICaixaFilter, ICaixaItemRecord } from '@services/CaixaService';
import { useThemeColor } from '@themes/Colors';
import React from 'react';

export type CaixaTableProps = {
    isLoading: boolean
    data: IData<ICaixaItemRecord, ICaixaFilter>
    faturaDetalheModal: IModalWindow
    tableContainerProps?: TableContainerProps
}

export function CaixaTable ({ isLoading, data: caixaData, faturaDetalheModal, tableContainerProps }: CaixaTableProps) {
    const formatter = useFormatter();
    const themeColor = useThemeColor();

    return (
        <DataTable 
            isLoading={isLoading} 
            itemCount={caixaData.itemsCount}
            tableContainerProps={tableContainerProps}
        >
            <TableHead>
                <TableRow>
                    <TableHeaderCell>ID</TableHeaderCell>
                    <TableHeaderCell>Data/Hora</TableHeaderCell>
                    <TableHeaderCell>Descrição</TableHeaderCell>
                    <TableHeaderCell>Débito</TableHeaderCell>
                    <TableHeaderCell>Crédito</TableHeaderCell>
                    <TableHeaderCell>Saldo</TableHeaderCell>
                </TableRow>
            </TableHead>
            
            <TableBody>
            {
                caixaData.items.map((caixaItemRecord, index) => {
                    return (
                        <TableRow key={index}>
                            <TableKeyCell>{caixaItemRecord.caixaItemId || ""}</TableKeyCell>
                            <TableCell>{formatter.toDate(caixaItemRecord.dataHora)}</TableCell>
                            <TableCell>{caixaItemRecord.faturaId !== undefined ? <Anchor onClick={caixaData.handleRowFocused(caixaItemRecord, faturaDetalheModal.open)}>{caixaItemRecord.descricao}</Anchor> : caixaItemRecord.descricao}</TableCell>
                            <TableCell className={themeColor.status.vermelho}>{caixaItemRecord.caixaTipoLancamentoId === EnumCaixaTipoLancamento.Debito ? formatter.toFloat(caixaItemRecord.valor) : ""}</TableCell>
                            <TableCell className={themeColor.status.verde}>{caixaItemRecord.caixaTipoLancamentoId === EnumCaixaTipoLancamento.Credito ? formatter.toFloat(caixaItemRecord.valor) : ""}</TableCell>
                            <TableCell>{formatter.toFloat(caixaItemRecord.saldo)}</TableCell>
                        </TableRow>
                    )
                })
            }
            </TableBody>
        </DataTable>
    )
}